<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description"
       [innerHTML]="getLangValue(stepData?.description)"></div>

  <div *ngIf="stepData?.options?.length > 0" class="survey-options-row">
    <div *ngFor="let option of pagedOptions" class="survey-option">
      <div class="option-text">{{ getLangValue(option.text) }}</div>
      <div *ngIf="getLangValue(option.description)?.trim() as desc" class="option-description">
        {{ desc }}
      </div>
    </div>
  </div>

  <button *ngIf="stepData?.options?.length > 0 && !allOptionsShown"
          type="button"
          (click)="onSeeMore()"
          class="c4g-raised-button show-more-btn">
    {{ translate.instant('buttons.more') }}
  </button>
</div>
